module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/121p5q0/tc-custom/9781467426909.jpg?1730410220482",
      "alt": "This image is the cover for the book The Letters of 2 Peter and Jude, The Pillar New Testament Commentary (PNTC)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Letters of 2 Peter and Jude, The Pillar New Testament Commentary (PNTC)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Filling a notable gap  in scholarship on 2 Peter and Jude,  Peter Davids artfully unpacks these two  neglected but fascinating epistles that  deal with the confrontation between the  Greco-Roman world and the burgeoning  first-century Jesus communities. Davids  firmly grasps the overall structure of  these oft-maligned epistles and presents  a strong case for 2 Peter and Jude as  coherent, consistent documents. Marked  by exceptional exegesis and sharp,  independent judgments, Davids's work  both connects with the latest  scholarship and transforms scholarly  insights into helpful conclusions  benefiting Christian believers.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Peter H. Davids\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Peter H. Davids is professor of biblical theology at St.Stephen's University, St. Stephen, New Brunswick. He is also the coeditor of Dictionary of the Later NewTestament and Its Developments.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0